import {
  PaymentGateway,
  PaymentGatewayResponse,
  PaymentMethodResponse,
  PaymentProviderResponse,
} from '../../models';

export function mapPaymentGateways(
  response: PaymentGatewayResponse,
): PaymentGateway[] {
  const methods = response.paymentMethodResponses ?? [];

  return methods.flatMap((method) =>
    (method.paymentMethodProviderResponses ?? []).map((provider) =>
      mapProvider(provider, method),
    ),
  );
}

function mapProvider(
  provider: PaymentProviderResponse,
  method: PaymentMethodResponse,
): PaymentGateway {
  return {
    id: provider.id,
    displayName: provider.displayName,
    logoUrl: provider.logoUrl,
    minimum: provider.minimum,
    maximum: provider.maximum,
    isDefault: provider.isDefault,
    paymentMethodType: method.paymentMethodType,
    paymentMethodName: method.displayName,
    providerType: provider.paymentMethodProviderType,
    providerTypeName: provider.paymentMethodProviderTypeName,
    bankAccount: provider.paymentMethodProviderBankAccountInformation,
  };
}
